import { BookingProviderRequestResponseItem } from '../../../integrated-client/models';

export interface IBookingResultsData {
  correlationId: string | null;
  bookingResponse: any;
  requestResponseData: BookingProviderRequestResponseItem[] | null;
}

export class BookingResultsData implements IBookingResultsData {
  correlationId: string | null;
  bookingResponse: any;
  requestResponseData: BookingProviderRequestResponseItem[] | null;

  constructor() {
    this.correlationId = null;
    this.bookingResponse = null;
    this.requestResponseData = null;
  }
}
